import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-dialog-info-purchase',
  templateUrl: './dialog-info-purchase.component.html',
  styleUrls: ['./dialog-info-purchase.component.scss']
})

export class DialogInfoPurchaseComponent {
  @Input() opened = false;
  @Output() closed = new EventEmitter();
  @Output() sendMail = new EventEmitter();

  constructor() { }

  public onSetYes() {
    this.sendMail.emit();
  }

  public close() {
    this.closed.emit();
  }

}
